import { Button, Css, ModalBody, ModalFooter, ModalHeader, SelectField, useModal } from "@homebound/beam";
import { useState } from "react";
import { DocumentType, PlanPackageAiProposalWorkflow } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useCreatePlanPackageAiProposalMutation } from "src/routes/libraries/plan-package-v2/components/overview/PlanPackageDocumentImportPanel.generated";
import { useGenerateTakeoffModalDocumentsQuery } from "src/routes/libraries/plan-package-v2/components/takeoffs/GenerateTakeoffModal.generated";
import { PlanPackageDetailsParams } from "src/routes/routesDef";

export function GenerateTakeoffModal() {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageDetailsParams>();
  const { closeModal } = useModal();
  const [selectedDocumentId, setSelectedDocumentId] = useState<string>();
  const { data, loading } = useGenerateTakeoffModalDocumentsQuery({
    variables: {
      filter: { readyPlanId: planPackageId, versionId: planPackageVersionId, documentType: [DocumentType.Plan] },
      page: {},
    },
  });
  const [createProposal, { loading: creating }] = useCreatePlanPackageAiProposalMutation();

  const documents = data?.documents.entities ?? [];
  const documentId = selectedDocumentId ?? (documents.length === 1 ? documents[0].id : undefined);
  const document = documents.find((d) => d.id === documentId);

  return (
    <>
      <ModalHeader>Generate Lines of Scope</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <p>
            Lines of scope are generated using this plan's current program data, options, locations, construction
            documents, and comparable plans.
          </p>
          <SelectField
            label="Construction Document"
            required
            disabled={loading}
            options={documents}
            value={documentId}
            onSelect={setSelectedDocumentId}
            getOptionLabel={(d) => d.name}
            getOptionValue={(d) => d.id}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="text" onClick={closeModal} />
        <Button
          label="Generate Lines"
          variant="ai"
          disabled={!document ? "Select a construction document" : creating ? "Generating..." : false}
          onClick={async () => {
            if (!document) return;
            await createProposal({
              variables: {
                input: {
                  planPackageId,
                  asset: { id: document.asset.id },
                  workflow: PlanPackageAiProposalWorkflow.GenerateTakeoff,
                },
              },
            });
            closeModal();
          }}
        />
      </ModalFooter>
    </>
  );
}
